import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DialogConfig } from 'src/app/core/components/dialog/dialog-config';
import { DialogRef } from 'src/app/core/components/dialog/dialog-ref';
import { Person } from 'src/app/lem/models/person/person';
import { CompanyService } from '../../../service/company.service';
import {CompanyScope} from '../../../../../models/companies/company-scope';
import {CompanyType} from '../../../../../models/companies/company-type';
import {Company} from '../../../../../models/companies/company';
import {CompanyStatus} from '../../../../../models/companies/company-status';

@Component({
  selector: 'app-inserimento-societa',
  templateUrl: './inserimento-societa-form.component.html',
  styleUrls: ['./inserimento-societa-form.component.css']
})
export class InserimentoSocietaComponent implements OnInit {


  statuses : CompanyStatus[];
  scopes : CompanyScope[];
  types : CompanyType[];
  persons : Person[];
  isEnabled: boolean = false

  vatNumberCheck : boolean = false;
  personSelected?: Person;

  formData: Company & {
    taxCode: string,
    statusDate: Date
  };
  formEdit: boolean ;

  newcompanyForm : FormGroup;


  constructor(
    private formBuilder : FormBuilder,
    private modalRef : DialogRef,
    private companyService : CompanyService,
    private dialogConfig : DialogConfig,
    private dialogRef : DialogRef,


  ) {
    this.newcompanyForm = formBuilder.group({
      name : ['',Validators.required],
      type : [null,Validators.required],
      scope : [null,Validators.required],
      owner : [null,Validators.required],
      taxCode : [null, [Validators.required,Validators.minLength(11),Validators.maxLength(16)]], // TSR-154 CHANGE TO taxNumber
      vatNumber : [null,[Validators.required,Validators.minLength(11),Validators.maxLength(11)]],
      status: [null,Validators.required],
      statusDate : [new Date(),Validators.required],
    })
   }

  ngOnInit() {
    //GET ALL DATA FROM MODALCREATE
      this.statuses = this.dialogConfig.data.statuses;
      this.scopes = this.dialogConfig.data.scopes;
      this.persons = this.dialogConfig.data.person;
      this.types = this.dialogConfig.data.types;
      if(this.dialogConfig.data.formSettings.formEdit){
        this.formEdit = this.dialogConfig.data.formSettings.formEdit;
        this.formData = this.dialogConfig.data.formSettings.formData;
        this.personSelected = this.persons.find(it => it.id === this.formData.owner.id);
        // TSR 181 FIX SCOPE,TYPE,OWNER IN EDIT MODE
        const formFormat = {
          name : this.formData.name,
          type : this.formData.type,
          scope: this.formData.scope,
          owner : this.personSelected,
          taxCode: this.formData.taxCode,
          vatNumber : this.formData.vatNumber,
          status: this.formData.statuses[this.formData.statuses.length - 1].status,
          statusDate: new Date(this.formData.statuses[this.formData.statuses.length - 1].validFrom)
        }
        this.newcompanyForm.setValue(formFormat);
      }
  }

  errorCheck() {
    console.log(this.newcompanyForm.get("vatNumber"))

    this.vatNumberCheck = !this.newcompanyForm.get("vatNumber").valid;
  }

  formReset(){
    this.newcompanyForm.reset();
  }

  onSaveCompany () {
    let companyData = {...this.newcompanyForm.value,status:"FONDATA"}
    this.dialogRef.close({data: companyData, edit:false});
  }
  onEditComplete () {
    const formValue = this.newcompanyForm.value;
    this.formData = {...this.formData ,
      name : formValue.name ,
      type : formValue.type,
      scope : formValue.scope,
      owner : formValue.owner,
      taxCode : formValue.taxCode,
      vatNumber : formValue.vatNumber,
      status : formValue.status,
      statusDate : formValue.statusDate
     }
     this.dialogRef.close({data: this.formData, edit:true})
  }

  autofillData () {
    //AUTOFILL DATA BY PERSON TYPE
    // LEGAL -> CODICE FISCALE - PARTITA IVA
    // PHYSICAL -> CODICE FISCALE
    this.personSelected = this.newcompanyForm.get('owner').value;
    if(this.personSelected.type === "LEGAL_ENTITY"){
      this.newcompanyForm.get('taxCode').setValue(this.personSelected.taxNumber);
      this.newcompanyForm.get('vatNumber').setValue(this.personSelected.vatNumber);
      this.errorCheck();
    }else{
      this.newcompanyForm.get('taxCode').setValue(this.personSelected.taxNumber);
      this.newcompanyForm.get('vatNumber').setValue("");
    }

    console.log(this.newcompanyForm.get("taxCode").value + " -> " + this.newcompanyForm.get("taxCode").valid)
    console.log(this.newcompanyForm.get("vatNumber").value + " -> " + this.newcompanyForm.get("vatNumber").valid)
  }

   selectCompare (objOne,objTwo) {
    return (objOne.id === objTwo.id);
  }



}
